"use client";
import CommonButton from "@/components/Button/CommonButton";
import ButtonRightArrow from "@/assets/iconComponents/ButtonRightArrow";
import { useTranslations } from "next-intl";

const JobButton = () => {
  const t = useTranslations();
  const handleJobClick = () => {
    window.open(
      "https://www.linkedin.com/company/finansfabriken/jobs/?viewAsMember=true",
      "_blank",
      "noopener,noreferrer"
    );
  };
  return (
    <CommonButton
      text={t("aboutus.contact_section.right.cta")}
      bgColor="#5C2483"
      textColor="#ECF4F8"
      className="large-button"
      svgImages={<ButtonRightArrow size={20} color="#ECF4F8" />}
      onClick={handleJobClick}
    />
  );
};

export default JobButton;
